import { Box } from "@mui/material";

import { calculateAgencyDistance, formatDistance, Coordinates } from "./utils";

interface DistanceDisplayProps {
  facilityCoordinates?: Coordinates;
  agencyCoordinates?: Coordinates;
  isPOBoxAddress?: boolean;
  sx?: object;
}

export const DistanceDisplay: React.FC<DistanceDisplayProps> = ({
  facilityCoordinates,
  agencyCoordinates,
  isPOBoxAddress = false,
  sx,
}) => {
  const distance = calculateAgencyDistance(facilityCoordinates, agencyCoordinates);

  const defaultSx = {
    mt: 1,
    fontSize: "0.875rem",
    ...sx,
  };

  // Show PO Box label instead of distance for PO Box addresses
  if (isPOBoxAddress) {
    return <Box sx={defaultSx}>PO Box</Box>;
  }

  // Show distance if available, otherwise show nothing (cleaner than "unavailable")
  if (distance !== undefined) {
    return <Box sx={defaultSx}>{`${formatDistance(distance)} from facility`}</Box>;
  }

  // Return null to hide the component when no distance is available
  return null;
};
